<template>
  <div class="invoice">
    <div class="uploadCourseFlag" v-if="showChooseInvoiceTypeFlag">
      <el-radio-group v-model="invoiceMakeType">
        <el-radio label="0" border>预开发票
          <el-tooltip effect="light" content="" placement="top-start">
            <div slot="content" class="tip-info">
              选择预开发票，表示充值之后就可以直接申请发票，开完发票后不可进行退款操作，且不可开具专用发票。
            </div>
            <i class="el-icon-question tip-icon"></i>
          </el-tooltip>
        </el-radio>
        <el-radio label="1" border>后开发票
          <el-tooltip effect="light" content="" placement="top-start">
            <div slot="content" class="tip-info">
              选择后开发票，表示订单使用之后才可以申请发票，未使用的金额可进行退款。
            </div>
            <i class="el-icon-question tip-icon"></i>
          </el-tooltip>
        </el-radio>
      </el-radio-group>

      <div style="width: 100%;margin-top: 30px" class="clearfix">
        <p style="float: left">温馨提示：只能选择一次开票类型，保存成功之后，后续开发票一律按照当前选择的开票方式开具发票。</p>
        <el-button @click="saveInvoiceMakeType()" v-loading="loading" :disabled="loading"
                   type="primary" style="float: right" size="small">
          保存
          <i class="el-icon-d-arrow-right"></i>
        </el-button>
      </div>


    </div>

    <div v-else>
      <el-card class="invoice-card">
        <el-row type="flex">
          <el-col v-if="invoiceMakeType == '1'" class="box-border box-left" :lg="18" :sm="14" :xs="24">
            <p class="invoice-total">可开票发票金额总计：<span class="sum"
                                                     style="color: #181818;">￥{{invoiceInfo.invoiceSum}}</span></p>
            <div class="category">
              <div>
                <p style="color:#181818;">可开票金额</p>
                <span class="sum">￥ {{invoiceInfo.invoiceSum}}</span>
                <el-button :disabled="invoiceInfo.invoiceSum <= 0" class="invoice-button" type="primary" size="small"
                           @click="toCreateFn">去开票
                </el-button>
              </div>
              <div class="sign">=</div>
              <div>
                <p class="sub-title">总计消费
                  <el-tooltip content="截至当前时点的总计消费金额" placement="top" effect="light">
                    <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                  </el-tooltip>
                </p>
                <span class="sub-sum">￥{{invoiceInfo.expenseAmount}}</span>
              </div>
              <div class="sign">-</div>
              <div>
                <p class="sub-title">历史已开票
                  <el-tooltip content="历史已经申请过开票，且未退票/红冲的金额" placement="top" effect="light">
                    <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                  </el-tooltip>
                </p>
                <span class="sub-sum">￥ {{invoiceInfo.invoicedAmount}}</span>
                <!-- <el-button class="invoice-button" type="text" style="color:#11A49F;">查看明细</el-button> -->
              </div>
              <!-- <div class="sign">-</div> -->
              <!-- <div>
                <p class="sub-title">开票中</p>
                <span class="sub-sum">￥ {{invoiceInfo.invoicingAmount}}</span>
              </div> -->
              <!-- <div>
                <p class="sub-title">本月不可开
                  <el-tooltip content="对于后付费产品，当月消费不能马上开票，需要次月账单日后才可开具发票" placement="top" effect="light">
                     <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                   </el-tooltip>
               </p>
                <span class="sub-sum">￥ 12131</span>
              </div> -->

               <div class="sign">-</div>
               <div>
                <p class="sub-title">赠送金  <el-tooltip content="平行云管理员赠送金额" placement="top" effect="light">
                  <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                </el-tooltip></p>
                <span class="sub-sum">￥ {{invoiceInfo.giftAmount}}</span>
              </div>
            </div>
          </el-col>
          <el-col v-if="invoiceMakeType == '0'" class="box-border box-left" :lg="18" :sm="14" :xs="24">
            <p class="invoice-total">可开票发票金额总计：<span class="sum"
                                                     style="color: #181818;">￥{{invoiceInfo.invoiceSum}}</span></p>
            <div class="category">
              <div>
                <p style="color:#181818;">可开票金额</p>
                <span class="sum">￥ {{invoiceInfo.invoiceSum}}</span>
                <el-button :disabled="invoiceInfo.invoiceSum<=0" class="invoice-button" type="primary" size="small"
                           @click="toCreateFn">去开票
                </el-button>
              </div>
              <div class="sign">=</div>
              <div>
                <p class="sub-title">总计消费
                  <el-tooltip content="截至当前时点的总计消费可开票金额" placement="top" effect="light">
                    <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                  </el-tooltip>
                </p>
                <span class="sub-sum">￥ {{invoiceInfo.cashAmount}}</span>
              </div>
              <div class="sign">-</div>
              <div>
                <p class="sub-title">历史已开票
                  <el-tooltip content="历史已经申请过开票，且未退票/红冲的金额" placement="top" effect="light">
                    <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                  </el-tooltip>
                </p>
                <span class="sub-sum">￥ {{invoiceInfo.invoicedAmount}}</span>
                <!-- <el-button class="invoice-button" type="text" style="color:#11A49F;">查看明细</el-button> -->
              </div>
              <!-- <div class="sign">-</div> -->
              <!-- <div>
                <p class="sub-title">开票中</p>
                <span class="sub-sum">￥ {{invoiceInfo.invoicingAmount}}</span>
              </div> -->
              <!-- <div>
                <p class="sub-title">本月不可开
                  <el-tooltip content="对于后付费产品，当月消费不能马上开票，需要次月账单日后才可开具发票" placement="top" effect="light">
                     <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                   </el-tooltip>
               </p>
                <span class="sub-sum">￥ 12131</span>
              </div> -->
            </div>
          </el-col>
          <el-col class="box-border box-right" :lg="6" :sm="10" :xs="24">
            <div class="invoice-info">
              <div class="info-head">
                <div>发票信息及地址管理</div>
                <!-- 个人用户且没有发票信息显示添加 || 企业用户没有发票信息显示添加 -->
                <router-link
                  v-if="(user.role === 1 && invoiceForm.title=='')||(user.role === 2 && invoiceForm.title=='')"
                  :to="{path: '/invoice/info',query:{type: 'add'}}" style="color:#11A49F;">添加
                </router-link>
                <router-link v-else to="/invoice/info" style="color:#11A49F;">编辑</router-link>
              </div>
              <div class="info-body">
                <div>
                  抬头（默认）：{{invoiceForm.title}}
                </div>
                <div>
                  税号：{{invoiceForm.creditCode}}
                </div>
                <div>
                  邮寄地址（默认）：{{address}}
                </div>
                <div>
                  电子邮件（默认）：{{email}}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="invoice-card">
        <el-table :data="invoiceData">
          <el-table-column type="index" label="序号" :min-width="50"></el-table-column>
          <template v-for="(item,index) in tableColumns">
            <el-table-column :prop="item.key" :label="item.label" :min-width="item.width"
                             :key="index"></el-table-column>
          </template>
          <el-table-column label="发票状态" :min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status===1" style="display: inline-block;width: 80px;color: #67C23A;">{{scope.row.statusSelf}}</span>
              <span v-else-if="scope.row.status===9" style="display: inline-block;width: 80px;color: #F56C6C;">{{scope.row.statusSelf}}</span>
              <span v-else style="display: inline-block;width: 80px;">{{scope.row.statusSelf}}</span>
              <el-button v-if="scope.row.status===9" size="small" type="text" @click="openRejectLog(scope.row)">驳回日志
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" :min-width="150" fixed="right">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="toDetail(scope.row)">详情</el-button>
              <!-- 状态为驳回 可以操作撤销和重新申请按钮 -->
              <el-button v-if="scope.row.status===9" size="small" type="text" v-loading="loading" :disabled="loading" @click="withdrawnFn(scope.row)">撤销
              </el-button>
              <el-button v-if="scope.row.status===9" size="small" type="text"  @click="reapplyFn(scope.row)">重新申请
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <PageComponent ref="pageInfo"></PageComponent>
      </el-card>
    </div>

    <!-- 驳回日志弹窗 -->
    <el-dialog
      width="500px"
      title="驳回日志"
      :visible.sync="dialogVisible"
      @close="handleClose"
      :close-on-click-modal="false">
      <div>
        <el-table :data="rejectLogTableData" style="width: 100%">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="createDateSelf" label="日期"></el-table-column>
          <el-table-column prop="note" label="驳回理由"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import PageComponent from "@/components/pageInfo/PageComponent";
  import {formatDateTime} from "@/utils/util.js"
  import {fmoney} from '@/utils/util'

  const columns = [
    {key: 'createDateSelf', label: '申请时间', width: '160'},
    {key: 'invoiceAmount', label: '发票总额', width: '100'},
    {key: 'note', label: '发票备注', width: '100'},
    {key: 'invoiceSendTypeSelf', label: '发票性质', width: '100'},
    // {key: 'statusSelf', label: '发票状态', width: '100'},
  ]
  export default {
    components: {PageComponent},
    data() {
      return {
        loading: false,
        invoiceData: [],
        tableColumns: columns,
        invoiceInfo: {
          invoiceSum: 0, // 可开票
          cashAmount: 0, // 预开发票总计消费可开票
          expenseAmount: 0,//后开发票总计消费
          giftAmount: 0,//赠送金额
          invoicedAmount: 0, // 历史已开票
          invoicingAmount: 0, // 开票中
        },
        showChooseInvoiceTypeFlag: false,
        invoiceType: '0',
        invoiceForm: {
          title: '', //发票抬头
          creditCode: '', // 统一社会信用代码
          address: '',
          email: ''
        },
        // 发票状态
        statusObj: {
          0: '开票中',
          1: '已开票',
          5: '撤销',
          9: '驳回'
        },
        address: '', // 默认地址
        email: '', // 默认邮箱
        dialogVisible: false, // 驳回日志弹窗
        rejectLogTableData: [], // 驳回日志表格
        invoiceMakeType: '0'
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    mounted() {
      this.$refs.pageInfo.initPagenator(this.getList, 10);

      this.getData();
      this.getIvoiceData();
      this.getAddressData();
      this.getEmailData();

    },
    methods: {
      // 获取发票金额信息
     async getData() {
        let params = {
          userId: this.user.userId
        }
        await this.getInvoiceMakeType().then(resp => {
          this.invoiceMakeType  = resp;
          this.getRequest("/ofc/getPersonalInvoiceAmount", params).then(res => {
            if (res.status == 200) {
              let data = res.data;
              if (data.code == 1000) {
                this.invoiceInfo = Object.assign(this.invoiceInfo, data.result);
                let sub = this.cal.add(this.invoiceInfo.invoicedAmount, this.invoiceInfo.invoicingAmount);
                if (this.invoiceMakeType == '1') {
                  this.invoiceInfo.invoiceSum = this.cal.sub(this.invoiceInfo.expenseAmount, sub + this.invoiceInfo.giftAmount);
                } else {
                  this.invoiceInfo.invoiceSum = this.cal.sub(this.invoiceInfo.cashAmount, sub);
                }
                this.getList();

              } else {
                this.$message.error(data.message)
              }
            }
          })
        })
      },
      // 获取发票历史
      getList() {
        let params = {
          userId: this.user.userId,
          page: this.$refs.pageInfo.currentPage,
          pageSize: 10,
        }
        this.getRequest('/ofc/invoiceLog/search', params).then(res => {
          // console.log(res)
          if (res.status == 200) {
            if (res.data.code == 1000) {
              this.invoiceData = res.data.result.records.map(item => {
                return Object.assign(item, {
                  createDateSelf: this.formatDateTime(item.createDate),
                  invoiceTypeSelf: item.invoiceType === 0 ? '增值税普通发票' : (item.invoiceType === 1 ? '增值税专用发票' : ''),
                  invoiceSendTypeSelf: item.invoiceSendType === 0 ? '纸质' : (item.invoiceSendType === 1 ? '电子' : ''),
                  statusSelf: this.statusObj[item.status],
                })
              })
              this.$refs.pageInfo.outputPagenator(res.data.result.total);
            }
          }
        })
      },
      // 开发票
      toCreateFn() {
        // 余额小于0时，不允许点击开发票，可开发票金额<1000只可开电子发票
        let userBalance = this.getUserAccount();
        let cutGiftAmount = (this.invoiceInfo.giftAmount - (this.invoiceInfo.cutGiftAmount == null ? 0 : this.invoiceInfo.cutGiftAmount));
        if (userBalance <= 0) {
          this.$message.warning('账户余额不足，请先充值！');
          return;
        } else  {
          this.$router.push({
            path: '/invoice/create',
            query: {
              invoiceMakeType: this.invoiceMakeType,//发票的类型，预先开发票还是后开发票
              cutGiftAmount: this.invoiceMakeType == '0' ? 0 : cutGiftAmount,//扣减金额，后开发票时需要扣减赠送的金额
            }
          })
        }
      },
      // 获取账户余额
      getUserAccount() {
        this.getRequest('/ofc/getPersonalAccount', {"userId": this.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              let userAccount = resp.data.result;
              let userBalance = userAccount.balance != null && userAccount.balance != ''
                ? userAccount.balance : 0;
              return userBalance;
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      // 获取发票信息
      getIvoiceData() {
        let params = {
          userId: this.user.userId
        }
        this.getRequest('/ofc/getPersonalInvoiceInfo', params).then(res => {
          // console.log(res)
          if (res.status == 200) {
            if (res.data.code == 1000) {
              let invoiceData = res.data.result;
              this.invoiceForm.title = invoiceData ? invoiceData.title : '';
              this.invoiceForm.creditCode = invoiceData ? invoiceData.creditCode : '';
            }
          }
        })
      },
      // 获取开发票类型：预开发票和后开发票
      getInvoiceMakeType() {
        if (this.user.role == '30') {
          return this.getRequest('/dev/system/ofc/invoiceMakeType/search', {userId: this.$route.query.userId}).then(resp => {
            if (resp.status == 200) {
              if (resp.data.code == 1000) {
                return resp.data.result.records[0].type;
              } else {
                Message.error(resp.data.message);
              }
            } else {
              console.error("error")
            }
          })
        } else {
          return this.getRequest('/ofc/getPersonalInvoiceMakeType', {}).then(resp => {
            if (resp.status == 200) {
              if (resp.data.code == 1000) {
                if(!resp.data.hasOwnProperty("result") ||  !resp.data.result.hasOwnProperty("type")){
                  this.showChooseInvoiceTypeFlag = true;
                  return ''
                }else {
                  return resp.data.result.type;
                }
              } else {
                Message.error(resp.data.message);
              }
            } else {
              console.error("error")
            }
          })
        }
      },
      // 获取寄送地址数据
      getAddressData() {
        let params = {
          userId: this.user.userId
        }
        this.getRequest('/uac/address/search', params).then(res => {
          if (res.status == 200) {
            if (res.data.code == 1000) {
              if (res.data.result.records.length) {
                this.addressData = res.data.result.records;
                if (res.data.result.records.length === 1) {
                  // 如果只有一条数据，直接认为是默认的
                  this.address = this.addressData[0].address;
                } else {
                  let info = this.addressData.find(item => item.defaultFlag === 1);
                  this.address = info ? info.address : this.addressData[0].address;
                }
              }
            }
          }
        })
      },
      // 获取邮箱列表
      getEmailData() {
        let params = {
          userId: this.user.userId
        }
        this.getRequest('/uac/email/search', params).then(res => {
          if (res.status == 200) {
            if (res.data.code == 1000) {
              if (res.data.result.records.length) {
                this.emailData = res.data.result.records;
                if (res.data.result.records.length === 1) {
                  // 如果只有一条数据，直接认为是默认的
                  this.email = this.emailData[0].email;
                } else {
                  let info = this.emailData.find(item => item.defaultFlag === 1);
                  this.email = info ? info.email : this.emailData[0].email;
                }
              }
            }
          }
        })
      },
      // 发票详情
      toDetail(row) {
        this.$router.push({
          path: '/invoice/detail',
          query: {
            invoiceLogId: row.id
          }
        })
      },
      // 打开驳回日志弹窗
      openRejectLog(row) {
        this.dialogVisible = true;
        let params = {
          ofcInvoiceLogId: row.id,
          page: 1,
          pageSize: 10000,
        }
        this.getRequest('/ofc/invoiceApprovalLog/search', params).then(res => {
          if (res.status == 200) {
            if (res.data.code == 1000) {
              this.rejectLogTableData = res.data.result.records.map(item => {
                return Object.assign(item, {
                  createDateSelf: this.formatDateTime(item.createDate),
                })
              })
            } else {
              this.$message.error(res.data.message);
            }
          }
        })
      },
      // 驳回日志弹窗关闭
      handleClose() {
        this.rejectLogTableData = [];
        this.dialogVisible = false;
      },
      // 撤销
      withdrawnFn(row) {
        this.$confirm('撤销发票索取, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            id: row.id,
            invoiceAmount: row.invoiceAmount,
            cutGiftAmount: row.cutGiftAmount,
          }
          this.loading = true;
          this.postRequestJson('/ofc/invoiceLog/withdrawn', params).then(res => {
            this.loading = false;
            if (res.status === 200) {
              if (res.data.code === 1000) {
                this.$message.success('撤销成功！');
                this.getData();
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        }).catch(() => {
          Message.info("已取消撤销操作！");
        });
      },
      // 重新申请
      reapplyFn(row) {
        // 余额小于0时，不允许点击开发票，可开发票金额<1000只可开电子发票
        let userBalance = this.getUserAccount();
        if (userBalance <= 0) {
          this.$message.warning('账户余额不足，请先充值！');
          return;
        } else if (this.invoiceInfo.invoiceSum < 1000) {
          this.$router.push({
            path: '/invoice/create',
            query: {
              isElectricOnly: '1',//只能开电子发票
              operation: 'reapply',//重新申请
              invoiceLogId: row.id,
              invoiceMakeType: this.invoiceMakeType,//发票的类型，预先开发票还是后开发票
            }
          })
        } else {
          this.$router.push({
            path: '/invoice/create',
            query: {
              invoiceLogId: row.id,
              operation: 'reapply',//重新申请
              invoiceMakeType: this.invoiceMakeType,//发票的类型，预先开发票还是后开发票
            }
          })
        }
      },


      saveInvoiceMakeType() {
        let invoiceMakeType = "预开发票";
        if (this.invoiceMakeType == "1") {
          invoiceMakeType = "后开发票";
        }
        this.$confirm('确定选择' + invoiceMakeType + '?只能选择一次开票类型，保存成功之后，后续开发票一律按照"' + invoiceMakeType + '"方式开具发票。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            type: this.invoiceMakeType
          }
          this.loading = true;
          this.postRequestJson('/ofc/invoiceMakeType/add', params).then(res => {
            this.loading = false;
            if (res.status === 200) {
              if (res.data.code === 1000) {
                this.$message.success('保存成功！');
                this.showChooseInvoiceTypeFlag = false;
                this.getData();
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        }).catch(() => {
          Message.info("已取消撤销操作！");
        });
      },
    }
  }
</script>
<style scoped>
  .invoice .invoice-card {
    margin-top: 15px;
  }

  .invoice .box-border {
    border: 1px solid rgb(237, 237, 237);
    padding: 12px 16px;
    box-sizing: border-box;
  }

  .invoice .box-left {
    margin-right: 15px;
  }

  .invoice .box-right {
    min-width: 360px;
  }

  .invoice .invoice-total {
    margin: 0;
    padding: 0 0 10px 0;
    border-bottom: 1px solid rgb(237, 237, 237);
  }

  .invoice .category {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .invoice .category > div {
    width: 22%;
    font-size: 12px;
  }

  .invoice .category .sign {
    font-weight: bold;
    font-size: 20px;
    min-width: 30px;
    margin-top: 35px;
    flex-shrink: 20;
    color: #181818;
  }

  .invoice .sub-title {
    color: rgb(153, 153, 153);
  }

  .invoice .sum {
    color: rgb(250, 106, 0);
    font-weight: 600;
    font-size: 16px;
  }

  .invoice .sub-sum {
    font-weight: 600;
    color: #181818;
    font-size: 16px;
  }

  .invoice-button {
    display: block;
    margin-top: 10px;
  }

  .invoice-info .info-head {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }

  .invoice-info .info-body {
    height: 125px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 12px;
    margin-top: 10px;
  }

  .uploadCourseFlag {
    margin: 20px 0;
    border: 1px solid #DCDFE6;
    padding: 20px;
    text-align: center;
  }

  .uploadCourseFlag .el-radio.is-bordered {
    height: 80px;
    width: 200px;
    padding: 19px 0;
  }

</style>
